import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "60c97d0e-197f-45b7-aec7-ef88e51dd5f8" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#60c97d0e-197f-45b7-aec7-ef88e51dd5f8)" }, k = { key: 0 }, v = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h512v167l-23.2 89.7L512 345v167H0V345l29.4-89L0 167z"
}, null, -1), p = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M0 167h512v178H0z"
}, null, -1), g = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ a({
  __name: "at",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), n = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), i("title", k, d(e.flagName), 1)) : f("", !0),
        v,
        p
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=at-7a825d96.js.map
